
import AccountDetail from "./AccountDetail";
export default AccountDetail;